import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import useAacFlags from "hooks/useAacFlags";
import { AccountContext } from "views/AccountWrapper";
import { SpaceAccessLevel, Stack } from "types/generated";
import { hasSpaceAccessAtLeast } from "utils/user";
import { hasAtLeastReadAccess } from "utils/access";

// FYI: the "stack.canWrite" check here is for legacy stacks (could be affected by access policies)
const useHasStackReadAccess = (): ((stack?: Stack) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useAacFlags();

  return useCallback(
    (stack?: Stack) => {
      if (!stack) {
        return false;
      }

      if (viewer.admin) {
        return true;
      }

      if (stack.canWrite) {
        return true;
      }

      return customAccessRoles
        ? hasAtLeastReadAccess(viewer, stack.spaceDetails?.id || stack.space)
        : hasSpaceAccessAtLeast(stack.spaceDetails?.accessLevel, SpaceAccessLevel.Read);
    },
    [customAccessRoles, viewer]
  );
};

export default useHasStackReadAccess;
